import { type FC, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { fractionalRgbToHex, hexOrRgbToRgbString } from "../ColorItem/helpers"
import { ChevronDown } from "lucide-react"

export interface IProductCardPreview {
  imageSrc: string
  sku: string
  brand: string
  productName: string
  color: string | null
  withoutVariantName?: boolean
}

export const ProductCardPreview: FC<IProductCardPreview> = ({
  imageSrc,
  sku,
  brand,
  productName,
  color,
  withoutVariantName = false,
}) => {
  const { t } = useTranslation()
  const [rbgColor, setRbgColor] = useState<string | null>("")

  useEffect(() => {
    if (color) setRbgColor(hexOrRgbToRgbString(color))
    else setRbgColor(null)
  }, [color])

  return (
    <div className="flex flex-col items-center gap-3">
      {imageSrc ? (
        <img
          src={imageSrc}
          alt={productName}
          className="aspect-square w-full rounded-lg border object-cover"
        />
      ) : (
        <div className="flex aspect-square w-full items-center justify-center rounded-lg bg-muted">
          <img alt={t("productCardPreview.noImageAlt")} src="/none-image.svg" className="h-10" />
        </div>
      )}

      <div className="flex flex-col items-center gap-1 text-center">
        {!withoutVariantName && (
          <div className="flex items-center gap-1.5">
            <div
              className="h-4 w-4 rounded-full border"
              style={{
                backgroundColor: rbgColor ? fractionalRgbToHex(rbgColor) : "#fff",
              }}
            />
            <span className="max-w-[140px] truncate text-sm">
              {sku?.length ? sku : t("productCardPreview.defaultVariantName")}
            </span>
            <ChevronDown className="h-3 w-3 text-muted-foreground" />
          </div>
        )}
        <p className="max-w-[180px] truncate text-sm font-semibold">
          {brand?.length ? brand : t("productCardPreview.defaultBrandName")}
        </p>
        <p className="max-w-[180px] truncate text-sm text-muted-foreground">
          {productName?.length ? productName : t("productCardPreview.defaultProductName")}
        </p>
      </div>
    </div>
  )
}
